export const DELETE_REPORT_FAILURE = 'DELETE_REPORT_FAILURE';

export const deleteReportFailure = error => ({
    type: DELETE_REPORT_FAILURE,
    payload: error,
    error: true,
});
